import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { avalaraAddressValidationService } from "@waytek/Services/AvalaraAddressValidation";
import { AvalaraAddressResponseModel } from "@waytek/Types/AvalaraValidationModel";

type AvalaraParameter = {
    shipTo: ShipToModel;
} & HasOnSuccess<AvalaraAddressResponseModel> &
    HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<
    AvalaraParameter,
    AvalaraAddressResponseModel,
    AvalaraAddressResponseModel
>;

export const SendDataToApi: HandlerType = async props => {
    const result = await avalaraAddressValidationService(props.parameter.shipTo);

    if (result.successful) {
        props.apiResult = result.result;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult);
    }
};

export const chain = [SendDataToApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const avalaraValidation = createHandlerChainRunner(chain, "AvalaraValidation");
export default avalaraValidation;
